export default __webpack_public_path__ + "static/media/login-card-rice.054c4df9.png";